require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-world-bank-oversight-of-asset-return-projects.json") })
        }
      }, "path---en-us-update-world-bank-oversight-of-asset-return-projects");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-world-bank-oversight-of-asset-return-projects!./.cache/json/en-us-update-world-bank-oversight-of-asset-return-projects.json
// module id = 876
// module chunks = 231608221292675